<div
    *ngIf="!localCookieConsent && !remoteCookieConsent"
    @fade
    id="cookieConsent"
>
    <div
        id="closeCookieConsent"
        (click)="consent()"
    >x</div>
    We use cookies to improve and customize your experience on our website. <a
        href="https://www.paragontesting.ca/paragon-legal-agreements-and-policies/cookie-policy/"
        target="_blank"
    >Learn more</a>.
    <a
        class="cookieConsentOK"
        (click)="consent()"
    >Yes, Accept Cookies.</a>
</div>
